import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.css',
})
export class ModalComponent {
  @Input() title: string = '';
  @Input() size: 'sm' | 'lg' | 'xl' = 'lg';
  @Input() show = false;
  @Input() hasFooter: boolean = false;

  @Output() closed = new EventEmitter<void>();

  close(): void {
    this.show = false;
    this.closed.emit();
  }

  get dialogClass(): string {
    return `modal-dialog modal-${this.size} modal-dialog-centered`;
  }
}
